import React, { useRef, useCallback } from "react";
import { Form, Row, Col, Select, Switch } from "antd";

const STATUS_OPTIONS = [
    { value: "true", label: "启用" },
    { value: "false", label: "禁用" },
];

/**
 * 用户列表筛选。关键词在筛选栏快捷搜索里，这里只放需要下拉确认的条件。
 * autoApply 时字段变化会防抖后直接生效。
 */
const UserListFilter = ({ onSearch, roles = [], accountTypeOptions = [], autoApply = false }) => {
    const [form] = Form.useForm();
    const debounceRef = useRef(null);

    const handleSearch = useCallback(() => {
        form.validateFields().then((values) => {
            onSearch(values);
        });
    }, [form, onSearch]);

    const handleValuesChange = useCallback(() => {
        if (!autoApply) return;
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            handleSearch();
        }, 300);
    }, [autoApply, handleSearch]);

    return (
        <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
            <Row gutter={24}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="account_type" label="账号类型" extra="只区分普通用户和 Agent 账号">
                        <Select allowClear placeholder="全部类型" options={accountTypeOptions} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="is_active" label="状态">
                        <Select allowClear placeholder="全部状态" options={STATUS_OPTIONS} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="role_id" label="角色">
                        <Select
                            allowClear
                            showSearch
                            placeholder="全部角色"
                            optionFilterProp="label"
                            options={roles.map((role) => ({ value: role.id, label: role.name }))}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="include_deleted" label="已归档" valuePropName="checked" extra="打开后，已归档账号会和在用账号一起出现">
                        <Switch checkedChildren="包含" unCheckedChildren="不含" />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default UserListFilter;
